import { render, staticRenderFns } from "./archivo.vue?vue&type=template&id=7b774155&scoped=true"
import script from "./archivo.vue?vue&type=script&lang=js"
export * from "./archivo.vue?vue&type=script&lang=js"
import style0 from "./archivo.vue?vue&type=style&index=0&id=7b774155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b774155",
  null
  
)

export default component.exports